import { EvidenceTicker } from "./EvidenceTicker";

export const Family = () => (
  <section className="bg-white py-16 sm:py-28 lg:py-32 rule" id="why-it-matters" data-testid="family-section">
    <div className="container-x grid lg:grid-cols-12 gap-8 lg:gap-16 items-center">
      <figure className="lg:col-span-5 lg:order-2">
        <div className="aspect-[4/3] sm:aspect-[4/5] overflow-hidden rounded-md">
          <img
            src="https://images.unsplash.com/photo-1543342384-1f1350e27861?auto=format&fit=crop&w=1200&q=80"
            alt="Two parents holding their newborn beside a sunlit apartment window"
            loading="lazy"
            decoding="async"
            className="h-full w-full object-cover object-center"
            data-testid="family-image"
          />
        </div>
      </figure>
      <div className="lg:col-span-7 lg:order-1 lg:pr-10">
        <div className="mb-8 sm:mb-10 lg:mt-2"><EvidenceTicker /></div>
        <p className="eyebrow mb-5 sm:mb-6" data-testid="family-eyebrow">For the people you love</p>
        <h2 className="h-editorial text-balance" data-testid="family-heading">
          You can’t protect them from everything. Start with the air they breathe and the water they drink.
        </h2>
        <p className="lead mt-6 sm:mt-7 max-w-xl" data-testid="family-copy">
          Testing identifies potential exposures in the places your family spends the most time, the bedroom, the kitchen,
          the tap, and gives you practical, prioritized next steps instead of guesswork.
        </p>
      </div>
    </div>
  </section>
);
